import { gql } from '@apollo/client';

// Consulta para obtener los métodos de pago
export const GET_PAYMENT_METHODS = gql`
  query {
    confOnSiteDeliveries {
      id
      paymentMethod
      minimumAcceptedValue
      maximumAcceptedValue
      disabledButtons
      showAlert
      alertMessage
    }
  }
`;

// Mutación para crear un método de pago
export const CREATE_PAYMENT_METHOD = gql`
  mutation ($object: confOnSiteDeliveries_insert_input!) {
    insert_confOnSiteDeliveries_one(object: $object) {
      id
    }
  }
`;

// Mutación para actualizar un método de pago
export const UPDATE_PAYMENT_METHOD = gql`
  mutation ($id: uuid!, $changes: confOnSiteDeliveries_set_input!) {
    update_confOnSiteDeliveries_by_pk(pk_columns: {id: $id}, _set: $changes) {
      id
    }
  }
`;

// Mutación para eliminar un método de pago
export const DELETE_PAYMENT_METHOD = gql`
  mutation ($id: uuid!) {
    delete_confOnSiteDeliveries_by_pk(id: $id) {
      id
    }
  }
`;